<template>
  <button
    :class="[
      'lp-chip',
      {
        'lp-chip--selected': selected,
        'lp-chip--with-icon-space': reserveIconSpace,
      },
    ]"
    :aria-checked="selected"
    :aria-disabled="disabled"
    type="button"
    @click="toggleSelect"
    @keydown.enter="toggleSelect"
    @keydown.space="toggleSelect"
    :disabled="disabled"
    :title="label"
    :role="role"
  >
    <span v-if="icon" class="lp-chip__icon">
      <lp-icon :name="icon" :size="iconSize" />
    </span>
    <span class="lp-chip__label">{{ label }}</span>
  </button>
</template>

<script setup lang="ts">
import type { iconType as IconTypes } from '@/components/icon/iconTypes'
import type { Props as IconProps } from '@/components/icon/LpIcon.vue'

import LpIcon from '@/components/icon'

export type Props = {
  label: string
  icon?: IconTypes
  selected?: boolean
  disabled?: boolean
  iconSize?: IconProps['size']
  reserveIconSpace?: boolean
  role?: 'radio' | 'checkbox'
}

export interface Emits {
  (e: 'update:selected', value: boolean): void
}

const debug = false

defineOptions({
  name: 'lp-chip',
})

const props = withDefaults(defineProps<Props>(), {
  icon: undefined,
  selected: false,
  disabled: false,
  iconSize: 'base',
  reserveIconSpace: true,
  role: 'radio',
})

const emit = defineEmits<Emits>()

function toggleSelect() {
  if (debug) {
    console.log('toggleSelect', props.label, props.selected, 'emitted', {
      selected: !props.selected,
    })
  }
  if (props.disabled) return
  emit('update:selected', !props.selected)
}
</script>
